<div class="grid-2col input-grid-gaps">
    @if (item) {
        <div class="flex-column gap-small">
            <div class="font-size-small">{{ prefix + 'service' | translate }}</div>
            <div>{{ item.serviceName || item.serviceTypeName || '-' }}</div>
        </div>
    } @else {
        <app-select-input [formField]="formDef.serviceId" [staticOptions]="serviceOptions" [autoSelectSingleOption]="false" [label]="prefix + 'service'"></app-select-input>
    }
    <app-select-input [formField]="formDef.tariffId" [staticOptions]="tariffOptions" [autoSelectSingleOption]="false" [label]="prefix + 'tariff'" [helpText]="prefix + 'tariffHelp'" (selectionChange)="applyTariff($event)"></app-select-input>
    <app-select-input [formField]="formDef.priceMode" [staticOptions]="priceModeOptions" [autoSelectSingleOption]="false" [label]="prefix + 'priceMode'" (selectionChange)="applyPriceMode($event)"></app-select-input>
    @if (formData().priceMode === 'fixed') {
        <app-number-input [formField]="formDef.fixedPriceOverride" [minFractionDigits]="2" [maxFractionDigits]="2" [label]="prefix + 'fixedPriceOverride'" [helpText]="prefix + 'priceHelp'"></app-number-input>
    } @else if (formData().priceMode === 'perUser') {
        <app-number-input [formField]="formDef.monthlyUserPriceOverride" [minFractionDigits]="2" [maxFractionDigits]="2" [label]="prefix + 'monthlyUserPriceOverride'" [helpText]="prefix + 'priceHelp'"></app-number-input>
    }
    <app-date-input [formField]="formDef.validFrom" [label]="prefix + 'validFrom'"></app-date-input>
    <app-date-input [formField]="formDef.validTo" [showClear]="true" [label]="prefix + 'validTo'"></app-date-input>
    <app-text-area-input class="span-2" [formField]="formDef.note" [label]="prefix + 'note'"></app-text-area-input>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="close()"
    >
        <app-button
            icon="pi-percentage"
            severity="primary"
            [disabled]="!item"
            [label]="'organization.platformBilling.actions.discounts'"
            [title]="!item ? ('organization.platformBilling.actions.saveServiceBeforeDiscounts' | translate) : ''"
            (clickEvent)="openDiscountsDialog()"
        ></app-button>
    </app-action-buttons>
</div>
